import React from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    Button,
    DialogContent,
    DialogActions,
    Dialog,
} from '@mui/material'
import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'

import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'
import styles from './ConfirmDialog.style'

const propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}

const ConfirmDialog = ({
    open,
    onConfirm,
    onCancel,
}) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()

    return (
        <Dialog
            id="cancel-process-confirm-dialog"
            keepMounted
            fullWidth
            maxWidth="sm"
            aria-labelledby="cancel-process-confirm-dialog"
            open={open}
            css={classes.dialogRoot}
        >
            <DialogContent css={classes.dialogContentRoot}>
                <img
                    alt="logo"
                    src={getGlobalAssetUrl('icons/warning.svg')}
                    css={classes.icon}
                />
                <Typography
                    variant="h3"
                >
                    {t('CANCEL_PROCESS')}
                </Typography>
            </DialogContent>
            <DialogActions
                css={classes.dialogActionsRoot}
            >
                <Button
                    data-testid="confirm-button"
                    css={classes.button}
                    onClick={onConfirm}
                >
                    {t('YES')}
                </Button>
                <Button
                    data-testid="cancel-button"
                    css={classes.button}
                    onClick={onCancel}
                >
                    {t('NO')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ConfirmDialog.propTypes = propTypes

export default ConfirmDialog
